export default {
  home: {
    hero: {
      title: 'Security camera & alarm system for private and commercial',
      subtitle: 'SSG Signaltechnik plans, installs and maintains modern video surveillance and alarm systems throughout the Rhine-Main region – from Hainburg via Offenbach, Frankfurt and Hanau to Darmstadt and Groß-Gerau. Individually tailored to your property, your requirements and the areas that really need protecting.',
      ctaPrimary: 'Request a free initial consultation',
      ctaSecondary: 'Start the Camera Planner',
    },
    trust: {
      '0': 'Individual planning',
      '1': 'Professional installation',
      '2': 'App setup',
      '3': 'Personal support',
      '4': 'Private and commercial',
    },
    service: {
      eyebrow: 'Our approach',
      title: 'More than just mounting cameras',
      lead: 'Every property is different. That is why we take a close look at your situation before suggesting a single camera. The full service includes:',
      steps: {
        '0': 'Analyse your needs and property',
        '1': 'Select camera type and viewing angle',
        '2': 'Check for possible blind spots',
        '3': 'Plan cabling, network and recording',
        '4': 'Mount and align professionally',
        '5': 'Set up the smartphone app and remote access',
        '6': 'Instruct you clearly',
        '7': 'Maintain the system on request',
      },
      more: 'Discover all services',
    },
    solutions: {
      eyebrow: 'Property types',
      title: 'Solutions for every property',
      lead: 'Whether a family home, a retail store or a production hall – we find the right solution for your requirements.',
      filter: { alle: 'All', privat: 'Private', gewerbe: 'Commercial', innen: 'Indoor', aussen: 'Outdoor', neu: 'New system' },
      more: 'Learn more',
      viewAll: 'View all solutions',
    },
    area: {
      eyebrow: 'Service area',
      title: 'Security cameras & alarm systems across the Rhine-Main region',
      lead: 'From our base in Hainburg we cover the entire metropolitan area: Frankfurt, Offenbach, Hanau, Darmstadt, Groß-Gerau and all surrounding communities. Planning, installation and maintenance of your security camera or alarm system – always personal and on site.',
      viewAll: 'View all service areas',
    },
    tech: {
      eyebrow: 'Technical planning',
      title: 'The right technology for the right goal',
      lead: 'It is not just about megapixels. A good camera system is created through the interplay of many factors.',
      points: {
        '0': { title: 'Indoor or outdoor', desc: 'Humidity, weather and temperature determine the camera choice.' },
        '1': { title: 'Light and night conditions', desc: 'Day/night and low-light solutions for every lighting situation.' },
        '2': { title: 'Overview or detail recognition', desc: 'Wide angle for the overall view or tele for faces and licence plates.' },
        '3': { title: 'Distance and mounting height', desc: 'The higher and further, the more resolution and better lens required.' },
        '4': { title: 'Viewing angle and lens', desc: 'Fixed focal length, varifocal or motorised – suited to the purpose.' },
        '5': { title: 'Recording and storage', desc: 'Local recorder with hard-disk-based storage as required.' },
        '6': { title: 'App access', desc: 'Live view and playback via smartphone, depending on system and configuration.' },
        '7': { title: 'Event notifications', desc: 'Push messages on movement or definable events, depending on the system.' },
        '8': { title: 'Expandability', desc: 'Existing systems can usually be expanded with additional cameras.' },
      },
    },
    process: {
      eyebrow: 'Process',
      title: 'How your project runs',
      lead: 'From the first enquiry to the finished system – transparent and personal.',
      steps: {
        '0': { title: 'Initial consultation', desc: 'We discuss your needs, your property and the areas you want to monitor.' },
        '1': { title: 'Site visit and planning', desc: 'On-site appointment to analyse light, angles, mounting points and cabling.' },
        '2': { title: 'Individual quote', desc: 'You receive a transparent quote with suitable technology and a clear scope of services.' },
        '3': { title: 'Installation and setup', desc: 'Professional mounting, network connection, recorder setup and app configuration.' },
        '4': { title: 'Instruction and support', desc: 'You learn how to operate the system. We are here for you – even afterwards.' },
      },
    },
    refs: {
      eyebrow: 'Reference projects',
      title: 'Completed projects',
      lead: 'A selection from our portfolio – from private property to commercial systems.',
      viewAll: 'Discover all solutions',
      items: {
        '0': { label: 'Private house – family home', desc: 'Complete system with 6 cameras, NVR and app connection' },
        '1': { label: 'Retail – boutique', desc: 'Sales floor and warehouse with 4 cameras and night vision' },
        '2': { label: 'Logistics – warehouse', desc: 'Large-area surveillance with wide angle and PTZ' },
        '3': { label: 'Practice – medical reception', desc: 'Discreet indoor surveillance with privacy masking' },
        '4': { label: 'Real estate – apartment building', desc: 'Entrance and outdoor areas with signage' },
      },
    },
    care: {
      eyebrow: 'Maintenance & support',
      title: 'SSG Care',
      lead: 'Your camera technology should work reliably in the long term. With SSG Care you get a flexible support subscription – cancel monthly or with an agreed term.',
      list: {
        '0': 'Regular system checks and firmware updates',
        '1': 'Support with app and access issues',
        '2': 'Help when changing smartphones',
        '3': 'Checking recording and storage',
        '4': 'Prioritised handling by arrangement',
      },
      cta: 'Discover SSG Care',
    },
    planner: {
      eyebrow: 'Interactive tool',
      title: 'The SSG Camera Planner',
      lead: 'Draw rooms or areas, mark important surveillance zones and test possible camera positions with field-of-view cones. The result is a non-binding preliminary plan for your conversation with us.',
      list: {
        '0': 'Draw rooms and walls',
        '1': 'Place camera icons via drag and drop',
        '2': 'Rotatable field-of-view cones with coverage rating',
        '3': 'Mark surveillance and privacy zones',
        '4': 'Send the result as an enquiry or print it',
      },
      cta: 'Start the Camera Planner',
    },
    faq: {
      eyebrow: 'Frequently asked questions',
      title: 'What customers often ask us',
      viewAll: 'View all questions',
      items: {
        '0': { question: 'How many cameras do I need?', answer: 'That depends on the size of your property, the areas to be monitored and the desired level of detail. After an initial consultation and a site visit, we create an individual proposal for you.' },
        '1': { question: 'Can I view the cameras on my smartphone?', answer: 'Yes, with most modern systems access via a smartphone app is possible. We set up the app connection directly during installation.' },
        '2': { question: 'Do cameras work in the dark?', answer: 'Yes, for outdoor areas and poorly lit interiors there are special day/night and low-light cameras with infrared or colour night vision.' },
        '3': { question: 'How much does a camera system cost?', answer: 'The cost depends on the number of cameras, the property, the cabling and the desired range of functions. We are happy to create an individual, non-binding quote for you.' },
      },
    },
    cta: {
      title: 'Let us find out together which solution suits your property.',
      lead: 'Call us, write to us – or start directly with the Camera Planner. We will get back to you promptly.',
      primary: 'Request a free initial consultation',
      secondary: 'Start the Camera Planner',
    },
  },
  company: {
    solutions: {
      home: { title: 'Home & property', description: 'From the front door to the garage – discreet surveillance for your home.' },
      retail: { title: 'Retail & hospitality', description: 'Checkout area, entrance and warehouse – professionally secured.' },
      office: { title: 'Office & practice', description: 'Reception, corridors and sensitive areas – planned with privacy in mind.' },
      warehouse: { title: 'Warehouse & logistics', description: 'Large-area surveillance with wide angle and night vision.' },
      workshop: { title: 'Workshop & trade', description: 'Robust cameras for tougher environments – workshops and outdoor areas.' },
      apartment: { title: 'Apartment buildings & real estate', description: 'Entrances, stairwells and outdoor areas – for tenants and owners.' },
    },
  },
};